import React, { useState, useEffect } from "react";
import BoxWrapper from "../../components/ui/boxWrapper";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import NumberFormat from "react-number-format";
import Box from "@mui/material/Box";
import viewImage from "./view.png";
import ToggleSwitch from "../../components/ui/ToggleSwitch/ToggleSwitch";
import { Snackbar, SnackbarContent } from "@mui/material";
import Alert from "@mui/material/Alert";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import RefreshIcon from "@mui/icons-material/Refresh";

import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";

import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Input } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import axios from "../../axios-order";
import Productxl from "./excel/ProductMaster.xlsx";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

function Service() {
  const [formData, setFormData] = useState({
    service_name: "",
    prefix: "",
    // Suffix: "",
    next_number: "",
  });
   const [isEditMode, setIsEditMode] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [fieldErrors, setFieldErrors] = useState({});
  const [rows, setRows] = useState([]);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [uploadHistory, setUploadHistory] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [isBoxVisible, setBoxVisible] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [responseData, setResponseData] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showUploadHistoryTable, setShowUploadHistoryTable] = useState(false);
  const [Product, setProduct] = useState(false);
  const [highlightedCell, setHighlightedCell] = useState({
    rowId: null,
    cellKey: null,
  });
  const [editedRowId, setEditedRowId] = useState(null);


  const handleProd = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const formatNumber = (value) => {
    return parseFloat(value).toFixed(2);
  };
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
  
    const businessEntityId = localStorage.getItem("business_entity_id");
    const mandatoryFields = [
      { name: "service_name", message: "Service is required" },
    ];
  
    // Validate mandatory fields
    const newFieldErrors = {};
    mandatoryFields.forEach(({ name, message }) => {
      if (!formData[name]) {
        newFieldErrors[name] = message;
      }
    });
  
    // Check for any field errors
    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors); // Set field errors
      return; // Exit if there are validation errors
    }
  
    // Create or update formData with business_entity_id and format numeric values
    const updatedFormData = {
      ...formData,
      business_entity_id: businessEntityId,
      prefix: formData.prefix,
      next_number: Number(formData.next_number),
    };
  
    const url = isEditMode
    ? `/einvoice/update_services` 
    : `/einvoice/add_services`; 
    const method = isEditMode ? 'post' : 'post';
    axios[method](url, updatedFormData)
      .then((response) => {
        console.log("Success:", response.data);
        if (response.data.status) {
          showSnackbar(response?.data?.message);
  
        
          setFormData({
            service_name: "",
            prefix: "",
            next_number: "",
          });
  
          handleToggle({ target: { checked: false } });
  
       
          refresh();
        } else {
          showSnackbar(response?.data?.message );
        }
      })
      .catch((error) => {
        // console.error("Error fetching data:", error);
        showSnackbar(error?.response?.data?.message,"error" );
      });
  };
  

  // const handleDownloadTemplate = () => {
  //   const link = document.createElement("a");
  //   link.href = Productxl;
  //   link.download = "ProductMaster.xlsx";
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  // const handleFileChange = async (event) => {
  //   const selectedFile = event.target.files[0];
  //   if (selectedFile) {
  //     setFile(selectedFile);

  //     const businessEntityId = localStorage.getItem("business_entity_id");
  //     const user = localStorage.getItem("user_id");

  //     setLoading(true);

  //     try {
  //       const base64File = await new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //           const base64String = `data:${selectedFile.type};base64,${btoa(
  //             reader.result
  //           )}`;
  //           resolve(base64String);
  //         };
  //         reader.onerror = reject;
  //         reader.readAsBinaryString(selectedFile);
  //       });

  //       await axios.post("/einvoice/import_product_master", {
  //         business_entity_id: businessEntityId,
  //         user: user,
  //         file: base64File,
  //       });

  //       setSnackbar({
  //         open: true,
  //         message: "File uploaded successfully.",
  //         severity: "success",
  //       });

  //       const formNumber = "101";
  //       const response = await axios.get(
  //         `/einvoice/get_data_upload_history/${businessEntityId}/${formNumber}`
  //       );

  //       console.log("Upload History:", response.data);
  //       setUploadHistory(response.data.record);

  //       setTimeout(() => {
  //         console.log("Refreshing data...");
  //         refresh();
  //       }, 1000);
  //     } catch (error) {
  //       console.error("Error uploading file:", error);
  //     } finally {
  //       setLoading(false);
  //       event.target.value = null;
  //     }
  //   } else {
  //     // alert('Please select a file first.');
  //   }
  // };

  const handleClear = () => {
    setFormData({
      service_name: "", 
      prefix: "",
      next_number: "",
    });
  };

  const handleCloseBox = () => {
    setBoxVisible(false);
  };



  // const handleExcel = async () => {
  //   const businessEntityIdRaw = localStorage.getItem("business_entity_id");

  //   if (!businessEntityIdRaw) {
  //     console.error("Business entity ID is missing");
  //     return;
  //   }

  //   try {
  //     // Check if response data is available
  //     if (!responseData) {
  //       console.error("Response data is missing");
  //       return;
  //     }

  //     const payloadData = {
  //       business_entity_id: businessEntityIdRaw,
  //       data: responseData,
  //     };

  //     const response = await axios.post(
  //       `/einvoice/download_error_data`,
  //       payloadData
  //     );

  //     console.log(response.data);

  //     const base64Data = response.data.file;
  //     if (base64Data) {
  //       const contentType =
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  //       const filename = "ProductUploadErrorLogs.xlsx";
  //       downloadBase64File(contentType, base64Data, filename);
  //     } else {
  //       console.error("Base64 data not found in the response");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Excel file:", error);
  //   }
  // };

  // const downloadBase64File = (contentType, base64Data, fileName) => {
  //   const linkSource = `data:${contentType};base64,${base64Data}`;
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;
  //   downloadLink.click();
  // };

  const refresh = async (pageNumber = 0, rowsPerPage = 25, searchTxt = "") => {
    const businessEntityId = localStorage.getItem("business_entity_id");
  
    try {
      // Fetch the data
      const response = await axios.get(`/einvoice/get_services/${businessEntityId}`);
  
      // Log the fetched data
      console.log("Upload History:", response.data);
  
      // Update the rows state with the received records
      if (response.data.records) {
        setRows(response.data.records); // Set the rows in your table
      }
  
      // Trigger a re-render or any other state change
      setRefreshTrigger((prev) => !prev);
    } catch (error) {
      console.error("Error refreshing data:", error);
      // Handle the error (e.g., show a message to the user)
    }
  };
  
  useEffect(() => {
    refresh(page, rowsPerPage, searchTerm);
  }, [page, rowsPerPage, searchTerm]);

  const searchInputOnchange = async (event) => {
    const value = event.target.value;
    setSearchText(value);
    await refresh(value);
  };

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    refresh(page, rowsPerPage, newSearchTerm);
  };

  const handleEyeIconClick = async (id) => {
    try {
      const response = await axios.get(`/einvoice/get_data_upload_json/${id}`);
      const { data } = response;
      setResponseData(data);
      if (
        data &&
        data.records &&
        data.records.records &&
        data.records.records.summary
      ) {
        setBoxVisible(true);
        setSummaryData(data.records.records.summary);
      }
      // Check if the response contains a message
      if (data && data.records && data.records.message) {
        if (!data.records.status) {
          setErrorMessage(data.records.message);
          setSnackbar({
            open: true,
            message: data.records.message,
            severity: "error",
          });
          handleCloseBox();
        } else {
          setErrorMessage("");
        }
      }
      setDialogData(data.records.records);

      // Toggle visibility
    } catch (error) {
      console.error("Error fetching data:", error);
  
    }
  };

  const cardStyle1 = {
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#6f9eaf",
    textAlign: "left",
    width: "300px",
    height: "70px",
    color: "white",
    fontSize: "20px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  };

  const cardStyle2 = {
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#007965",
    textAlign: "left",
    width: "300px",
    height: "70px",
    color: "white",
    fontSize: "20px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  };

  const cardStyle3 = {
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#eb596e",
    textAlign: "left",
    width: "300px",
    height: "70px",
    color: "white",
    fontSize: "20px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    handleToggle({ target: { checked: true } });
    // Scroll the page up by 20px
    window.scrollTo({
      top: window.pageYOffset - 580,
      behavior: "smooth",
    });
    setEditedRowId(row.id);
    setTimeout(() => {
      setEditedRowId(null);
    }, 7000);
    setFormData({
      id: row.id || "",
      service_name: row.service_name || "",   
      prefix: row.prefix || "",
      next_number: row.next_number || "",
    });
  };
  
  const handleDelete = (id) => {
    const businessEntityId = localStorage.getItem("business_entity_id");
    axios
      .delete(`/einvoice/delete_einvoice_services/${businessEntityId}/${id}`)
      .then((response) => {
        
        showSnackbar(response?.data?.message, "error");
        refresh(); 
      })
      .catch((error) => {
        console.error("Error deleting service:", error);
     
      });
  };
  

  const handleToggleChange = () => {
    setShowUploadHistoryTable(!showUploadHistoryTable);
  };

  const handleToggle = (event) => {
    setProduct(event.target.checked);
    setIsEditMode(false)
    // Clear form data when toggle is turned off
    if (!event.target.checked) {
      setFormData({
        id: null,
        service_name: "",
        prefix: "",
        next_number: "",
      });
    }
  };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          {/* <ToggleSwitch
       onChange={handleToggleChange}
       value={showUploadHistoryTable}
       label="Upload Product"
     /> */}
          <div className="container">
            <div>
              <input
                type="checkbox"
                className="toggle-switch"
                id="default1"
                onChange={handleToggle}
                checked={Product}
              />
              <label htmlFor="default1"></label>
            </div>
            <p> Add Service</p>
          </div>
        </div>
      </div>
      {showUploadHistoryTable && (
        <BoxWrapper boxTitle="Product Uploads">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              {/* <Button onClick={handleDownloadTemplate}>
                <GetAppIcon style={{ fontSize: "20px" }} />
                Download Template
              </Button>
              <Button component="label" size="small" color="primary">
                <PublishIcon style={{ fontSize: "20px" }} />
                UPLOAD TEMPLATE
                <input
                  accept=".xlsx"
                  name="file"
                  type="file"
                  hidden
                  onChange={handleFileChange} // Handle file input change
                />
              </Button> */}
            </div>

            <Button
              variant="contained"
              onClick={() => refresh()}
              style={{
                marginTop: "10px",
                marginLeft: "440px",
                backgroundColor: "white",
                border: "none",
                color: "#3e71c2", // To ensure text is visible on white background
                boxShadow: "none", // Optional: Remove the box-shadow if desired
              }}
              startIcon={<RefreshIcon />}
            >
              REFRESH
            </Button>
          </div>
          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      paddingLeft: "15px",
                    }}
                  >
                    Upload Date
                  </TableCell>

                  <TableCell
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      paddingLeft: "15px",
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      paddingLeft: "15px",
                    }}
                  >
                    Upload Type
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      paddingLeft: "15px",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadHistory.map((record) => (
                  <TableRow key={record.id}>
                    <TableCell style={{ padding: "3px", paddingLeft: "15px" }}>
                      {record.upload_date}
                    </TableCell>
                    <TableCell style={{ padding: "3px", paddingLeft: "15px" }}>
                      {record.status}
                    </TableCell>
                    <TableCell style={{ padding: "3px", paddingLeft: "15px" }}>
                      {record.upload_type}
                    </TableCell>
                    <TableCell style={{ padding: "3px", paddingLeft: "15px" }}>
                      <IconButton onClick={() => handleEyeIconClick(record.id)}>
                        {/* <VisibilityIcon /> */}
                        <img
                          src={viewImage}
                          alt="View"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </BoxWrapper>
      )}

      {isBoxVisible && (
        <BoxWrapper
          boxTitle="Uploads Details"
          exportToExcelEnable={true}
          // exportToExcelFn={handleExcel}
          cutIcon={true}
          closeBoxWapper={handleCloseBox}
        >
          {summaryData ? (
            <div>
              {/* Cards Section */}
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={cardStyle1}>
                  <div>Total Records</div>
                  <div>{summaryData.total_records}</div>
                </div>
                <div style={cardStyle2}>
                  <div>Valid Records</div>
                  <div>{summaryData.valid_records}</div>
                </div>
                <div style={cardStyle3}>
                  <div>Invalid Records</div>
                  <div>{summaryData.invalid_records}</div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                {summaryData.invalid_records !== 0 && (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>GSTIN</TableCell>
                          <TableCell>INVOICE NUMBER</TableCell>
                          <TableCell>ROW#</TableCell>
                          <TableCell>ERRORS</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dialogData && Array.isArray(dialogData.details) ? (
                          dialogData.details.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{}</TableCell>
                              <TableCell>{}</TableCell>
                              <TableCell>{item.row}</TableCell>
                              <TableCell>
                                {item.errors_in
                                  ? Object.entries(item.errors_in).map(
                                      ([field, errors], i) => (
                                        <div key={i}>
                                          {field}: {errors.join(", ")}
                                        </div>
                                      )
                                    )
                                  : "No errors"}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4}>No data available</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </div>
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </BoxWrapper>
      )}

      {Product && (
        <BoxWrapper boxTitle="Service Master">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Service"
                  name="service_name"
                  value={formData.service_name}
                  onChange={handleProd}
                  variant="outlined"
                  error={!!fieldErrors.service_name}
                  helperText={fieldErrors.service_name || ""}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Prefix"
                  name="prefix"
                  value={formData.prefix}
                  onChange={handleProd}
                  variant="outlined"
                  error={!!fieldErrors.prefix}
                  helperText={fieldErrors.prefix || ""}
                />
              </Grid>

              {/* <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Suffix"
                  name="Suffix"
                  value={formData.Suffix}
                  onChange={handleProd}
                  variant="outlined"
                />
              </Grid> */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Next Number"
                  name="next_number"
                  value={formData.next_number}
                  onChange={handleProd}
                  allowNegative={false}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="flex-start">
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ width: 120 }}
                  >
                  {isEditMode ? 'Update' : 'Add'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12} style={{ marginTop: "16px" }}></Grid>
            </Grid>
          </form>
        </BoxWrapper>
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        sx={{ mt: 4 }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }} // Positioned at the top-right corner
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          variant="filled"
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <BoxWrapper
        boxTitle="Service Details"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearchChange}
        // exportToExcelEnable={true}
        // exportToExcelFn={handleExportExcel}
      >
        <div
          style={{
            maxHeight: "400px",
            overflow: "auto",
            scrollbarWidth: "thin",
          }}
        >
          <Table sx={{ tableLayout: "auto" }}>
            <TableHead>
              <TableRow>
                {["SERVICE", "PREFIX", "NEXT NUMBER",'ACTION'].map(
                  (header) => (
                    <TableCell
                      key={header}
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                        padding: "8px 16px",
                      }}
                    >
                      {header}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
    {rows && rows.length > 0 ? (
      rows.map((row) => (
        <TableRow
          key={row.id}
          style={{
            backgroundColor: editedRowId === row.id ? "lightgreen" : "transparent",
            transition: "background-color 4s ease",
          }}
        >
          <TableCell style={{ padding: "8px 16px" }}>{row.service_name}</TableCell>
          <TableCell style={{ padding: "8px 16px" }}>{row.prefix}</TableCell>
          <TableCell style={{ padding: "8px 16px" }}>{row.next_number}</TableCell>
          <TableCell style={{ padding: '8px 16px' }}>
          <EditIcon style={{ cursor: 'pointer' }} 
           sx={{
            '&:hover': {
              color: 'blue',  // Change to your desired hover color
            },
          }}
          onClick={() => handleEdit(row)} />
           <IconButton
                        onClick={() => handleDelete(row.id)}
                       
                      >
                        <DeleteIcon
                          style={{ cursor: "pointer" }}
                          sx={{ "&:hover": { color: "red" } }}
                        />
                      </IconButton>
        </TableCell>
       
        </TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={3} style={{ textAlign: "center" }}>
          No data found!
        </TableCell>
      </TableRow>
    )}
  </TableBody>
          </Table>
        </div>
      </BoxWrapper>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 1000, 3000]}
        component="div"
        count={rowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => {
          setPage(newPage);
          refresh(newPage, rowsPerPage, searchTerm);
        }}
        onRowsPerPageChange={(event) => {
          const newRowsPerPage = parseInt(event.target.value, 10);
          setRowsPerPage(newRowsPerPage);
          setPage(0);
          refresh(0, newRowsPerPage, searchTerm);
        }}
      />
    </div>
  );
}

export default Service;
